import React from 'react';
import { refreshProductFromBifrost } from '../../redux/actions/manageAssetActions';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Button, styled } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { getProductsTabSearchOptions } from '../../redux/actions/productActions';

const refreshBtnTxt = 'refresh';

const RefreshButton = styled(Button)({
	paddingBottom: '4px',
});

function ProductRefreshBtn({ productId, productUUID }) {
	const dispatch = useDispatch();

	const refreshBtnClick = () => {
		dispatch(refreshProductFromBifrost({ productId, productUUID })).then(() => {
			dispatch(getProductsTabSearchOptions(productId));
		});
	};
	return (
		<RefreshButton color="primary" startIcon={<RefreshIcon />} onClick={refreshBtnClick}>
			{refreshBtnTxt}
		</RefreshButton>
	);
}

export default ProductRefreshBtn;
